// ═══════════════════════════════════════════════════════════════════
//  QUÉ ENTREGA ES ESTA PANTALLA
//
//  El mismo número que `server/version.js`. Los dos se suben a mano en cada
//  entrega, y TIENEN QUE IR IGUALES.
//
//  Este número queda cocido dentro del `npm run build`. O sea que no dice
//  "qué ficheros se han copiado", dice "QUÉ COMPILACIÓN está sirviendo el
//  navegador", que es lo que de verdad importa: se puede copiar la carpeta
//  client entera y, si no se compila, el navegador sigue con la de antes.
//
//  Si el aviso de versiones sale aunque esté todo instalado, es que al subir
//  una entrega se cambió uno de los dos números y no el otro.
// ═══════════════════════════════════════════════════════════════════

export const ENTREGA_PANTALLA = 326;
export const FECHA_PANTALLA   = '2026-11-04';
